import cloneDeep from "lodash/cloneDeep";
import {
  STORE_LOCATOR_LIST,
  CHANGE_SELECTED_COUNTRY,
  CHANGE_SELECTED_SHOP
} from "../constants";

type StoreLocatorState = {
  storeCountry: string[];
  selectedCountry: string;
  selectedShop: Record<string, any>;
  locatorList: any[];
  cityList: any[];
  otherInfo: string;
};

const initialState: StoreLocatorState = {
  storeCountry: [],
  selectedCountry: "",
  selectedShop: {},
  locatorList: [],
  cityList: [],
  otherInfo: ""
};

const getSelectedShops = (locatorList: any[], selectedCountry: string) => {
  const filtered = locatorList.filter(
    (item: any) => item.country === selectedCountry
  );
  const withOrder = filtered.filter((item: any) => Number(item.sortOrder) > 0);
  const withoutOrder = filtered.filter(
    (item: any) => !(Number(item.sortOrder) > 0)
  );
  return [
    ...withOrder.sort(
      (a: any, b: any) => Number(a.sortOrder) - Number(b.sortOrder)
    ),
    ...withoutOrder
  ];
};

const storeLocatorList = (
  state: StoreLocatorState,
  { locatorList, countryId, countryData }
) => {
  const newStoreCountry = new Set<string>();
  const newLocationList = cloneDeep(locatorList);
  let updatedLocatorList = newLocationList.map(item => {
    let itemCountryId = item.countryId;
    const countryDetails =
      countryData &&
      countryData.find(item => {
        return item.countryId === itemCountryId;
      });

    item.country = (countryDetails && countryDetails.countryName) || "";
    return item;
  });

  updatedLocatorList.forEach((item: any) => newStoreCountry.add(item.country));
  const _selectedShop =
    updatedLocatorList &&
    updatedLocatorList.filter((item: any) => item.countryId === countryId);
  const selectedCountry =
    _selectedShop && _selectedShop.length && _selectedShop[0].country;
  const sortedCityList = getSelectedShops(updatedLocatorList, selectedCountry);
  const firstCity = sortedCityList[0];
  return {
    ...state,
    locatorList: updatedLocatorList,
    storeCountry: [...newStoreCountry],
    selectedCountry,
    selectedShop: firstCity &&
      firstCity.shops &&
      firstCity.shops[0] && {
        ...firstCity.shops[0],
        station_id: firstCity.shops[0].id,
        countryName: selectedCountry
      },
    cityList: sortedCityList
  };
};

const changeSelectedCountry = (
  state: StoreLocatorState,
  { selectedCountry }
) => {
  const sortedCityList = getSelectedShops(state.locatorList, selectedCountry);
  const firstCity = sortedCityList[0];
  return {
    ...state,
    selectedCountry,
    cityList: sortedCityList,
    selectedShop: firstCity &&
      firstCity.shops &&
      firstCity.shops[0] && {
        ...firstCity.shops[0],
        station_id: firstCity.shops[0].id,
        countryName: selectedCountry
      }
  };
};

const changeSelectedShop = (state: StoreLocatorState, { selectedShop }) => ({
  ...state,
  selectedShop: { ...selectedShop, countryName: state.selectedCountry }
});

const storeLocatorReducer = (state = initialState, action) => {
  switch (action.type) {
    case STORE_LOCATOR_LIST:
      return storeLocatorList(state, action);
    case CHANGE_SELECTED_COUNTRY:
      return changeSelectedCountry(state, action);
    case CHANGE_SELECTED_SHOP:
      return changeSelectedShop(state, action);
    default:
      return state;
  }
};

export default storeLocatorReducer;
